export const APPOINTMENT_PROVIDER_OPTIONS = {
  FULLNAME: "Appointment.Provider.FullName",
  FIRST_NAME: "Appointment.Provider.FirstName",
  LAST_NAME: "Appointment.Provider.LastName",
  TITLE: "Appointment.Provider.Title",
  SUFFIX: "Appointment.Provider.Suffix",
  SIGNATURE: "Appointment.Provider.Signature"
};

export const APPOINTMENT_PROVIDER_MENU_OPTIONS = {
  title: "Appointment Provider",
  menu: [
    {
      title: "Appointment Provider - Full Name",
      value: APPOINTMENT_PROVIDER_OPTIONS.FULLNAME
    },
    {
      title: "Appointment Provider - First Name",
      value: APPOINTMENT_PROVIDER_OPTIONS.FIRST_NAME
    },
    {
      title: "Appointment Provider - Last Name",
      value: APPOINTMENT_PROVIDER_OPTIONS.LAST_NAME
    },
    {
      title: "Appointment Provider - Title",
      value: APPOINTMENT_PROVIDER_OPTIONS.TITLE
    },
    {
      title: "Appointment Provider - Suffix",
      value: APPOINTMENT_PROVIDER_OPTIONS.SUFFIX
    },
    {
      title: "Appointment Provider - Signature",
      value: APPOINTMENT_PROVIDER_OPTIONS.SIGNATURE
    }
  ]
};
